module.exports = __webpack_public_path__ + "img/xiaoshou-b.e1086aac.svg";